/**
 * Load Hotjar functions
 */

(function (pmw, $, undefined) {

	pmw.load_hotjar_pixel = function () {

		try {
			// @formatter:off
			(function(h,o,t,j,a,r){
				h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
				h._hjSettings={hjid:pmwDataLayer.pixels.hotjar.site_id,hjsv:6};
				a=o.getElementsByTagName('head')[0];
				r=o.createElement('script');r.async=1;
				r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
				a.appendChild(r);
			})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
			// @formatter:on

			pmwDataLayer.pixels.hotjar.loaded = true;

		} catch (e) {
			console.error(e)
		}
	}

}(window.pmw = window.pmw || {}, jQuery));
